module.exports = __webpack_public_path__ + "media/images/flags/nl-92ee5a790e65b67d4f0e05018bb6637c.svg";